import { supabase } from '@/lib/supabase'
import { triggerNotificationPush } from '@/lib/push'

export const createUserNotification = async ({ recipientId, actorId, postId = null, commentId = null, type = '' } = {}) => {
  if (!recipientId || !actorId || !type || recipientId === actorId) return null

  const { data, error } = await supabase
    .from('notifications')
    .insert({
      recipient_id: recipientId,
      actor_id: actorId,
      post_id: postId,
      comment_id: commentId,
      type,
    })
    .select('id')
    .single()

  if (error) {
    throw error
  }

  const notificationId = data?.id || null
  if (notificationId) {
    await triggerNotificationPush(notificationId)
  }

  return notificationId
}
